/**
* In this file contains the Admin login screen UI designs and login forms functionality
**/
import { validate } from '../../services/ValidationService';
import constantVariables from '../../dataset/constantVariables.json';
import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { hashPassword, generatePrivateKey, encryptPassword } from '../../services/UtilsService';
import usePasswordToggle from '../../services/passwordService';
import ApiService from '../../services/ApiService';
import i18n from 'i18next';

//Admin Login form
function HospitalAdminLogin() {

    //Initialize Variable declaration	
    const [data, setData] = useState({});
    const [error, setError] = useState({});
    const navigate = useNavigate();
    const [showPassword, togglePassword] = usePasswordToggle(false);

    /**
    * Validation schema for login form
    * @username -  pass the valid email or mobile number
    * @password - pass the password value
    **/
    const fields = [
        { name: 'username', validation: Yup.string().required().email() },
        { name: 'password', validation: Yup.string().required() }
    ];

    /** 
     * To handle input fields change function
     * @e - we capture the input fields events
     **/
    const handleChange = async (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
        const Errors = await validate({ [name]: value }, fields);
        setError({ ...error, [name]: Errors[name] });
    };

    /**
    * To handle login submit function
    * @e - we capture the login form events
    **/
    const handleSubmit = async (e) => {
        e.preventDefault();
        const Errors = await validate(data, fields);
        setError(Errors);
        if (!Object.keys(Errors).length) {
            var request = {};
            request.username = data.username;
            request.password = await hashPassword(data.password);
            request.verified = true;
            request.isHospitalAdmin = true;
            var response = await ApiService.adminLogin(request);
            if (response.status === 200) {
                if (response.data.shouldRedirect) {
                    navigate('/create-password'); // Custom logic for redirect
                    localStorage.setItem('role', 4);
                    localStorage.setItem('userId',response.data.userId);
                } else {
                    const language = response.data.language;
                    i18n.changeLanguage(language);
                    const privateKey = generatePrivateKey(data.password, response.data.passwordEPK);
                    localStorage.setItem('privateKey', privateKey);
                    localStorage.setItem('encyptPassword', encryptPassword(data.password));
                    localStorage.setItem('role', response.data.role);
                    navigate('/hospital/admin/dashboard');
                    toast.success(response?.data?.message);
                }
            } else {
                toast.error(response?.data?.message);
            }
        }
    };

    //Component Initialize function
    useEffect(() => {
        // To check if the token exists or not
        var token = localStorage.getItem('token');
        if (token) {
            const role = parseInt(localStorage.getItem('role'));
            // Navigate based on the user's role
            if (role === 3) {
                navigate('/admin/dashboard');
            } else if (role === 4) {
                navigate('/hospital/Admin/dashboard'); // For hospital admin role
            } else {
                navigate('/physician/dashboard');
            }
        }
        // eslint-disable-next-line
    }, []);


    /** This function is used to navigate to forgot password page **/
    const navigateForgot = () => {
        sessionStorage.setItem('role', 4);
        navigate('/forgot-password');
    }

    return (
        <>
            {/** Admin Login page  **/}
            <main className="login-sec">
                <div className="container">

                    <section className="register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                        <div className="container">
                            {/** Logo **/}
                            <div className="row justify-content-center">
                                <div className="col-lg-12">
                                    <div className="d-flex justify-content-center pb-5">
                                        <Link to='/' className="login-logo d-flex align-items-center">
                                            <img src="/assets/img/nurture-logo.svg" alt="lo" />
                                        </Link>
                                    </div>

                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-md-12 col-lg-10">
                                    <div className="wrap d-md-flex">
                                        <img src="/assets/img/Hadmin-login-img.jpg" alt="lo" />

                                        {/** Login form **/}
                                        <div id="loginForm">
                                            <h1>{constantVariables.auth.hospitalLogin}</h1>
                                            <h5>{constantVariables.auth.loginTitle}</h5>

                                            <form onSubmit={handleSubmit} autoComplete="off">
                                                <div className="form-group">
                                                    <label className="mb-1">{constantVariables.auth.userName}</label>
                                                    <input type="text" value={data.username ? data.username : ''} name="username" onChange={handleChange} className="form-control" placeholder={constantVariables.auth.userName} />
                                                    <i className="iconly-Light-User"></i>
                                                    {error && error.username && <span className="text-danger">{error.username}</span>}
                                                </div>
                                                <div className="form-group mb-4">
                                                    <label className="mb-1">{constantVariables.auth.password}</label>
                                                    <input value={data.password ? data.password : ''} type={showPassword ? "text" : "password"} name="password" onChange={handleChange} className="form-control" placeholder={constantVariables.auth.password} />
                                                    <i className="iconly-Light-Lock"></i>
                                                    <span className="eyeicon">
                                                        <i className={showPassword ? 'far fa-eye' : 'far fa-eye-slash'} onClick={togglePassword}></i>
                                                    </span>
                                                    {error && error.password && <span className="text-danger">{error.password}</span>}
                                                </div>
                                                <div className="form-group d-flex mb-4">
                                                    <div className="w-50 text-start">
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                            <label className="form-check-label" htmlFor="flexCheckChecked">{constantVariables.auth.rememberMe}</label>
                                                        </div>
                                                    </div>
                                                    <div className="w-50 text-end">
                                                        <span onClick={navigateForgot} className="text-tmPink">{constantVariables.auth.forgotPassword}?</span>
                                                    </div>
                                                </div>
                                                <div className="mb-5">
                                                    <button type="submit" className="btn btn-tmBlue w-100">{constantVariables.landing.login}</button>
                                                </div>
                                            </form>
                                        </div>
                                        {/** Login form end **/}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>

                </div>
            </main>
            {/** Login page end **/}
        </>
    );
}


export default HospitalAdminLogin;
